export function toDateString(isoDateTime: string): string {
  return isoDateTime.split('T')[0] ?? isoDateTime;
}
